import { render, staticRenderFns } from "./TeamList.vue?vue&type=template&id=b829a232&scoped=true"
import script from "./TeamList.vue?vue&type=script&lang=ts"
export * from "./TeamList.vue?vue&type=script&lang=ts"
import style0 from "./TeamList.vue?vue&type=style&index=0&id=b829a232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b829a232",
  null
  
)

export default component.exports